module.exports = "<form class=\"inp-subtle inp-type fragment-type\" :class=\"{'inp-type-active':options}\" @submit.prevent.stop=submit @keydown=keydown> <span class=inp-subtle-span v-text=term||model||placeholder></span> <input type=text v-model=term :placeholder=model||placeholder @blur=blur @input=input @focus=input> <div class=ref-select v-if=options> <div class=ref-option :class=\"{'ref-ghost':$index===ghost}\" v-for=\"opt in options\" v-text=opt.item||opt.action track-by=item @mouseenter=\"ghost=$index\" @mousedown=confirm(opt.item)></div> </div> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputType.vue
 ** module id = 138
 ** module chunks = 0
 **/